/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import {
    pageContext,
    get
} from 'ctm-util-functions';

import { formAddOnUIComponent } from 'ctm-css-themes';

import { SimpleFlexbox } from '../../flexbox/flexbox';

import { getResolvedConfigSchema } from './address_config_schema';
import { FieldRow } from '../containers/field_row/field_row';

import labelStyles from '../label/label.css';
import styles from '../containers/field_row/field_row.css';

class Address extends Component {

    constructor(props) {
        super(props);
        this.configSchema = getResolvedConfigSchema(props.schema.properties);

        this.formElementFactory = pageContext.getProps().factories.formElementFactory;
    }

    /**
     * Render a title of the Field row. Used for multi fields row. - moved from FieldRow
     * @returns {Node} - title header row that may contain a toggle
     */
    getTitle = () => {
        const { title } = this.configSchema;
        if (!title) {
            return null;
        }

        // title|label row addon width style
        const addonWidthClass = get(this.props, 'schema.field.addonWidth', 'default');
        const className = formAddOnUIComponent[`addon_width_${addonWidthClass}`];

        return (
            <SimpleFlexbox className={className} row gapless="xs" contentBetween="xs" itemsCenter="xs">
                <label className={labelStyles.variant_multiple_field}>
                    <span className={styles.multiple_field_heading}>{title}</span>
                </label>
            </SimpleFlexbox>
        );
    };

    /**
     * Return the element schema for the toggle element used for switching between autocomplete and MFA and vice-verse
     * @param {String} toggleType - The toggleType to render - autoCompleteToggle or mfaToggle
     * @returns {Object} - The element schema for the toggle element
     */
    getToggleElementSchema = (toggleType) => {
        const { dispatch } = this.props;
        const toggleElementSchema = this.configSchema[toggleType];
        const { onClick } = toggleElementSchema;
        const onClickFunc = () => {
            if (onClick.setState) {
                this.setState({ [onClick.setState.key]: onClick.setState.value });
            }
            if (onClick.actions) {
                onClick.actions.map((action) => dispatch(action));
            }
        };
        return {
            ...toggleElementSchema,
            onClick: onClickFunc
        };
    };

    /**
     * Return the Autocomplete component wrapped in a FieldRow
     * @returns {Node} - The Autocomplete component wrapped in a FieldRow
     */
    getAutoCompleteCombo = () => {
        const { selectedValues } = this.props;
        const schema = {
            ...this.configSchema.autoComplete,
            elements: [
                this.getToggleElementSchema('autoCompleteToggle')
            ]
        };
        return <FieldRow schema={schema} selectedValues={selectedValues} />;
    };

    /**
     * Return the MFA component wrapped in a FieldRow
     * @returns {Node} - The MFA component wrapped in a FieldRow
     */
    getMFA = () => {
        const { selectedValues } = this.props;
        const schema = {
            ...this.configSchema.mfa,
            elements: [
                this.getToggleElementSchema('mfaToggle')
            ]
        };
        return <FieldRow schema={schema} selectedValues={selectedValues} />;
    };

    render = () => {
        return (
            <>
                {this.getTitle()}
                {this.getMFA()}
                {this.getAutoCompleteCombo()}
            </>
        );
    };

}

Address.propTypes = {
    schema: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    selectedValues: PropTypes.object
};

export { Address };
